import { Injectable } from "@angular/core";
import { AngularFireDatabase } from "angularfire2/database";
import * as firebase from "firebase";
import { Observable } from "rxjs/Observable";
import { HistoryData } from "./history";
import { Utilities } from "./utilities";

@Injectable()
export class CouponsData {

  private action: string = "update";

  constructor(
    private afDb: AngularFireDatabase,
    private historyData: HistoryData,
    private utilities: Utilities,
  ) { }

  public getCouponsByClient(clientId: string, eventId: string): Observable<any[]> {
    let ref = `Clients/${clientId}/Interactivity/Coupon`;
    if (this.utilities.validateEventIdParam(eventId)) {
      ref = `Clients/${clientId}/Event/${eventId}/Coupon`;
    }
    return this.afDb.list<any>(ref).
      valueChanges();
  }

  public getCouponsByReference(clientId: string, reference: string, eventId: string): Promise<any[]> {
    let ref = `Clients/${clientId}/Interactivity/Coupon`;
    if (this.utilities.validateEventIdParam(eventId)) {
      ref = `Clients/${clientId}/Event/${eventId}/Coupon`;
    }
    return this.afDb.database.ref(ref)
      .orderByChild("reference")
      .equalTo(reference)
      .once("value")
      .then((snap) => snap.val());
  }

  public getCouponsById(clientId: string, couponId: string, eventId: string): Observable<any> {
    let ref = `Clients/${clientId}/Interactivity/Coupon/${couponId}`;
    if (this.utilities.validateEventIdParam(eventId)) {
      ref = `Clients/${clientId}/Event/${eventId}/Coupon/${couponId}`;
    }
    return this.afDb.object<any>(ref).valueChanges();
  }

  public createCoupon(clientId: string, eventId: string, coupon: any) {
    if (!coupon.id) {
      this.action = "create";
      coupon.id = this.afDb.createPushId();
    } else {
      this.action = "update";
    }
    if (!coupon.reference) { coupon.reference = this.utilities.generateID(false, 5); }

    let ref = `Clients/${clientId}/Interactivity/Coupon/${coupon.id}`;
    if (this.utilities.validateEventIdParam(eventId)) {
      ref = `Clients/${clientId}/Event/${eventId}/Coupon/${coupon.id}`;
    }

    return new Promise((resolve, reject) => {
      return this.afDb.database.ref(ref)
        .update(coupon)
        .then(() => {
          return this.historyData.set(
            `Coupon content`,
            "coupons",
            this.action,
            coupon,
          );
        })
        .then(() => {
          resolve(coupon);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  public updateReferred(client: string, referredData: any) {
    return new Promise((resolve, reject) => {
      return this.afDb.database.ref(`Clients/${client}/Referred`)
        .update(referredData)
        .then(() => {
          this.historyData.set(
            `Referred content`,
            "referred",
            "update",
            referredData,
          );
          resolve(referredData);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  public sharedCoupon(client: string, coupon: any, userId: string) {
    return new Promise((resolve, reject) => {
      return this.afDb.database.ref(`Clients/${client}/Coupons/${coupon.id}/quota`)
        .once("value")
        .then((r) => {
          const quota = r.val();
          if (quota > 0) {
            return this.afDb.database.ref(`Clients/${client}/UserCoupons/${userId}/${coupon.id}`)
              .once("value")
              .then(async (result) => {
                if (!result.val()) {
                  return await this.afDb.database.ref(`Clients/${client}/UserCoupons/${userId}/${coupon.id}`)
                    .update({ ...coupon, assigned_at: firebase.database.ServerValue.TIMESTAMP })
                    .then(async () => await this.afDb.database.ref(`Clients/${client}/Coupons/${coupon.id}/quota`)
                      .transaction((value) => value > 0 ? value -= 1 : 0))
                    .then(() => resolve(true))
                    .catch((error) => {
                      reject(error);
                    });
                } else {
                  return resolve(false);
                }
              });
          } else {
            return resolve(-1);
          }
        });
    });
  }

  public getReferralCouponRef(clientId: string) {
    // console.log("id client", clientId);
    return this.afDb.object(`/Clients/${clientId}/Referred`)
      .query.ref;
  }
}
 // end file



// WEBPACK FOOTER //
// ./src/providers/coupons.ts